import { Center, Spinner } from '@chakra-ui/react';

export function Loading() {
    return (
        <Center height='full' width='full'>
            <Spinner size='xl' color='brand.accent' />
        </Center>
    );
}
